// Imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components/macro';
import { BannerListItem } from '.';
import { Link } from 'react-router-dom';


// Styled components
const Wrapper = styled.li`
	max-width: 21.25rem;
	padding: 1.6rem 1.2rem;
	
	width: 100%;
	
	border-radius: 0.3125rem;
	border: 2px solid hsl(36, 56%, 69%);
	background-color: hsl(0, 0%, 100%);
`;

const Prefix = styled.span`
	color: hsl(206, 45%, 64%);
	font-size: 3.75rem;
	font-weight: 500;
	line-height: 1;
`;

const Label = styled.strong`
	display: block;
	font-size: 1.5rem;
	font-weight: 500;
	line-height: 1;
	color: hsl(206, 83%, 27%);
	padding-left: 0.1rem;
	margin-top: 0.31rem;
`;

const Description = styled.p`
	&&& {
		color: hsl(206, 25%, 20%);
		font-size: 1.125rem;
		line-height: 1.375rem;
		padding-left: 0.1rem;
		margin-top: 0.9375rem;
	}
`;

const ItemLink = styled.a`
	all: unset;
	cursor: pointer;
	display: flex;
	color: hsl(206, 83%, 27%);
	margin-top: 0.9375rem;
	padding-bottom: -9.774rem;
	justify-content: center;
	
	&:hover {
		text-decoration: underline;
	}
	
	&:focus-visible {
		outline: -webkit-focus-ring-color auto 0.0625rem;
	}
`;


// Function component
const Item: React.FC<BannerListItem> = ({ prefix, icon, label, description, link }) => (
	<Wrapper>
		{prefix && <Prefix>{prefix}</Prefix>}
		{icon && (
			<Prefix>
				<FontAwesomeIcon icon={icon} />
			</Prefix>
		)}
		<Label>{label}</Label>
		<Description>{description}</Description>
		{link && (
			<ItemLink as={'to' in link ? Link : 'a'} {...link}>
				{link.text} →
			</ItemLink>
		)}
	</Wrapper>
);

export default Item;
